export const dashboardPage = [
    {
        RevenueReport: 'Revenue report contains the revenue of each services against the mentioned time period.',
        label: "Revenue Report"
    },
    {
        LabelGrossRevenue: 'Label Gross Revenue is the total revenue generated from the provided content.',
        label: "Label Gross Revenue"
    },
    {TimeDuration: 'Time Duration is the period during which the content is monetized.', label: "Time Duration"},
    {OverAll: 'Overall is the service wise total Gross Revenue against the mentioned time duration.', label: "OverAll"},
    {Total: 'Month wise Gross Revenue generated on all services.', label: "Total"},
]

export const userHomePage = [
    {CPManager: 'Content Provider can be added or managed under this section.', label: "CP Manager"},
    {Finance: 'Internal members of finance can be added or managed under this section.', label: "Finance"},
    {CommercialTeam: 'For members responsible for dealing with the CPs directly.', label: "Commercial Team"},
    {MediaTeam: 'Internal members of media team can be added or managed under this section.', label: "Media Team"},
]

export const userContractPage = [
    {Contract: 'Contract page with allowed licence.', label: "Contract"},
]

export const creatUserPage = [
    {createUser: 'Create user by completing the profile.', label: "Create User"},
    {Role: 'Assign Role to the user.', label: "Role"},
]

export const referencePage = [
    {
        createConsultant: 'This section contains any consultant through which a content provider is onboarded.',
        label: "consultant"
    },
    {
        feature: 'Information related to the consultant can be added or removed in this section and is optional.',
        label: "feature"
    },
]
export const createReferencePage = [
    {create: 'Create consultant', label: "consultant"},
    {
        userDetails: ' Add consultant details under the section.',
        label: "User Details"
    },
    {
        bankDetails: ' Add bank details of the consultant.',
        label: "User Details"
    },
]
export const createCPPage = [
    {create: 'Newly onboarded CP profile is created in the section', label: "create"},
    {Profile: 'Add CP profile information in the section.', label: "Profile"},
    {Label: 'Add CP label information in the section..', label: "Label"},
]
export const CPManagementPage = [
    {management: 'Content providers can be added or removed under this section.', label: "CP Management"},
    {add: 'New CP can be added by clicking the + button.', label: "ADD +"},
]
export const ContentsPage = [
    {
        management: 'In this section, monetized content of the content provider can be viewed for each label.',
        label: "Content Management"
    },
    {add: 'New Content can be added by clicking the + button.', label: "ADD +"},
]
export const CreateContentPage = [
    {create: 'Create Content', label: "create"},
]

export const servicesPage = [
    {revenue: 'this is revenue of cp-rrpasdad'},
    {revenueReport: 'this is revenue report of cp-rrp'},
]
export const CreateLabelServicePage = [
    {create: 'Create Label Service', label: "create"},
]

export const labelServicePage = [
    {LabelTitle: 'Label Title is the title of the label against each CP.', label: "Label Title"},
    {CPId: 'ID of the parent label.', label: "CP ID"},
    {Service: 'Label content is deployed on the services mentioned in the column.', label: "Service"},
    {CPRev: 'The revenue share percentage of the content provider.', label: "CP Rev Share"},
    {RVRev: 'The revenue share percentage of Rockville.', label: "Rockville Rev Share"},
    {RRev: 'The revenue share of the consultant  if available.', label: "consultant  Revenue Share"},
    {Territories:'You can set the territories of each label by clicking to the globe icon below.',label: "Territories"},
    {Action:'You can edit the service type of the label by clicking the icon below.',label: "Action"},
    {
        // status: 'The current status of the label whether the label is Active/Inactive on the service. Labels can be inactive upon the termination of a contract.',
        // label: "Status"
    },
]
export const createServicePage = [
    {create: 'Create Service', label: "create"},
]

export const parentLabelPage = [
    {revenue: 'this is revenue of cp-rrp'},
    {revenueReport: 'this is revenue report of cp-rrp'},
]
export const LabelsPage = [
    {OldLabelID: 'This column contains previous IDs against each label.', label: "Old Label ID"},
    {LabelID: 'Label ID is the ID generated against each label.', label: "Label ID"},
    {LabelTitle: 'Label Title is the Name of the label of each Content Provider.', label: "Label Title"},
    {LabelCategory: 'Categories of the label can be viewed under this column.', label: "Label Category"},
    {LabelStatus: 'Categories of the label can be viewed under this column.', label: "Label Status"},
    {POCName: 'This column indicates whether the label currently is Active or Inactive.', label: "POC-1 Name"},
]
export const CreateParentLabelPage = [
    {revenue: 'this is revenue of cp-rrp'},
    {revenueReport: 'this is revenue report of cp-rrp'},
]
export const GenerateReportsPage = [
    {
        UploadReports: 'This is section where user can upload the service revenue excel file daily or monthly',
        label: "Upload Reports"
    },
    {ServiceWise: 'Label wise streams and duration report of each service is uploaded in the field.', label: "Service Wise"},
    {TopLineRevenue: 'Top line revenue of the service can be entered in this field.', label: "Top Line Revenue"},
    {ServiceRevenue: 'Top line revenue can be entered in this field', label: "Service Revenue"},
    {CompanyShare: 'Rockville Revenue Share percentage will be entered in this field', label: "Company Share"},
    {BadDebt: 'Reconciliation difference percentage against the operator is entered in the field.', label: "Bad Debt"},
    {
        DigitalAndMarketingCost: 'Cost incurred for promotional purposes of the service is entered in the field. You can enter multiple costs by pressing the + button. If the cost is in USD then the exchange rate can be entered by clicking the $ button',
        label: "Digital & Marketing Cost"
    },
    {ContentWise: 'Track wise streams and duration report can be uploaded in this section.', label: "Content Wise"},
]
export const ServiceReportPage = [
    {
        MonthlyServiceRevenue: 'Revenue against each service can be viewed in this section. ',
        label: "Monthly Service Revenue"
    },
    {
        Date: 'Revenue share for the date mentioned. Filter wise search can be done on the “Filter” field Date Format: DD/MM/YYYY.',
        label: "Date"
    },
    {
        TotalRevenue:
            'The revenue received for specific service before reconciliation difference.',
        label: "Total Revenue"
    },
    {
        ShareableRevenue:
            'The revenue to be distributed among labels after excluding the reconciliation difference or bad debt.',
        label: "Shareable Revenue"
    },

    {
        DigitalSpent:
            'Cost incurred in the service is mentioned in the field.',
        label: "Digital Spent"
    },
    {
        TotalStreams:
            'The total no of streams against the mentioned date can be viewed in the field.',
        label: "Total Streams"
    },
    {
        TotalDuration:
            'The total watch time in minutes against the mentioned date can be viewed in the field.',
        label: "Total Duration"
    },

]
export const LabelServiceReportPage = [
    {
        LabelServiceReport: 'Reports for specific date or duration can be viewed by using “Filter” tab.',
        label: "Label Service Report"
    },
    {ReportTypeFilter: 'Set report type filter i.e monthly,weekly,yearly,daily', label: "Report Type Filter"},
    {
        Date: `Revenue share for the date mentioned. Filter wise search can be done on the “Filter” field.
        Date Format: DD/MM/YYYY`, label: "Date"
    },
    {Export: 'export file according to set filter', label: "Date"},
    {Type: 'Acquisition type for each label i-e MG, Non-MG, N/A.’', label: "Type"},
    {Drag: 'Drag a column header above the table and check detail by colum', label: "Drag"},
    {ParentLabel: 'Name of the content provider is mentioned under the field.', label: "Parent Label"},
    {LabelID: 'ID for the specified label.', label: "Label ID"},
    {CPId: 'ID for the parent label', label: "CP ID"},
    {LabelName: 'Name of the label against the specified CP', label: "Label Name"},
    {Stream: 'Number of qualified streams against the mentioned date can be viewed in the field', label: "Stream"},
    {StreamP: 'Qualified Streams percentage of the label from the Total Streams.', label: "Stream %"},
    {Duration: 'Watch time in minutes against the mentioned date can be viewed in the field.', label: "Duration"},
    {DurationP: 'Duration percentage of the label on the Total Duration. ', label: "Duration %"},
    {LabelShare: 'Revenue share percentage for the specific label', label: "Label Share"},
    {LabelRevenue: 'Label share for the specific label.', label: "Label Revenue"},
    {LabelGrossRevenue: 'Total revenue received for the specific label.', label: "Label Gross Revenue"},
    {
        Qualified: 'Streams are considered qualified if the duration of the content is greater than 15 sec.',
        label: "Qualified"
    },
    {
        UnQualified: 'Streams are considered unqualified if the duration of the content is less than 15 sec.\n',
        label: "UnQualified"
    },
]
export const ContentReportPage = [
    {
        ContentReport: 'Content wise stats of the service are viewed under this section.',
        label: "Content Report"
    },
    {
        Date: 'Revenue share for the date mentioned. Filter wise search can be done on the “Filter” field.',
        label: "Date"
    },
    {
        ContentID: 'Unique ID generated for each content.',
        label: "Content ID"
    },
    {
        Title: 'Name of the content.',
        label: "Title"
    },
    {
        Type: 'Content type shows whether the content is Audio, Video or FULLTRACK (Audio + Video).',
        label: "Type"
    },
    {
        LabelName: 'The label under which the content is provided.',
        label: "Label Name"
    },
    {
        Category: 'This field shows the genre of the content provided.',
        label: "Category"
    },
    {
        SubCategory: 'It shows the Language of the content.',
        label: "Sub Category"
    },
    {
        Singer: 'The name of the artist.',
        label: "Singer"
    },
    {
        Streams: 'The number of times the content is streamed.',
        label: "Streams"
    },
    {
        StreamsPercent: 'Percentage consumed from the  total streams for the specific month.',
        label: "Streams Percent"
    },
    {
        Duration: 'The watch time of the content in minutes.',
        label: "Duration"
    },
    {
        DurationPercent: 'Percentage consumed from the  total duration for the specific month.',
        label: "Duration Percent"
    },
   
    {
        ContentGrossRevenue: 'Total revenue received by the content',
        label: "Content Gross Revenue"
    },
    {
        LabelShare: ' Revenue share percentage for the specific label',
        label: "Label Share"
    },
   
    {
        ContentRevenue: 'Content share for the specific',
        label: "Content Revenue"
    },
   
   
    {
        Status: 'Status shows if the content is active on the service.',
        label: "Status"
    },

]
export const LicensedLabelServicePage = [
    {revenue: 'this is revenue of cp-rrpqqqqqq'},
    {revenueReport: 'this is revenue report of cp-rrp'},
]
export const LabelLicensedTerritoriesPage = [
    {revenue: 'this is revenue of cp-rrp'},
    {revenueReport: 'this is revenue report of cp-rrp'},
]

export const InvoiceGeneratePage = [
    {
        invoiceGenerate: 'The section of the portal is used for invoice generation against the content provider for revenue clearance.' +
            'Payment duration is selected by using the “Filter” option of the selected label.' +
            'Invoice is generated and notified to the CP by email and SMS.', label: "Invoice Generate"
    },
    {LabelType: 'Label type filers the label of the mentioned type.', label: "Label Type"},
    {CPId: 'Unique ID generated for the Content Provider.', label: "CP ID"},
    {CPName: 'Name of the Content Provider or parent label.', label: "CP Name"},
    {
        LabelShare: 'Revenue share percentage of the mentioned cp.',
        label: "Label Share (%)"
    },
    {LabelGrossRevenue: 'Total revenue received for the specific cp.', label: "Label Gross Revenue"},
    {
        TotalRevenue: ' Label share for the specific cp.',
        label: "label Revenue"
    },

]

export const InvoiceReportPage = [
    {
        invoiceReport: 'Notified invoices are managed under this section.\n' +
            'Invoices generated for the specific duration is viewed by using the “Filter” option.\n',
        label: "Invoice Report"
    },
    {CPId: 'Unique ID generated for the content provider.', label: "CP ID"},
    {
        CPName: 'Name of the content provider or parent label.', label: "CP Name"
    },
    {
        LabelShare: 'Revenue share percentage of the mentioned cp.',
        label: "Label Share"
    },
    {
        LabelRevenue: ' Label share for the specific cp.',
        label: "Label Revenue"
    },
    {
        LabelGrossRevenue: ' Total revenue received for the specific cp.',
        label: "Label Gross Revenue"
    },
    {
        Status: 'Status of the invoice are shown under this field and can be changed according to the process defined.User cannot be able to change the status once the status is “Paid”.',
        label: "Status"
    },
    {StartDate: 'The selected start date for which the status is generated.', label: "Start Date"},
    {EndDate: 'The selected end date for which the status is generated.', label: "End Date"},
    {
        UploadInvoice: 'User can upload the invoice for the specific term under this field once notified.',
        label: "UploadInvoice"
    },
]
